<div
  class="table-filter-container"
  *ngIf="
    !filterContainerModel.hideContainer &&
    filterContainerModel.filters &&
    filterContainerModel.filters.length > 0
  "
>
  <div class="inner">
    <div
      *ngIf="showMetaButtons"
      class="filter-metanav d-flex justify-content-between align-items-center"
    >
      <div class="pos-left d-flex">
        <ng-container *ngFor="let button of addTemplateMeta['left']">
          <ng-container *ngTemplateOutlet="button"></ng-container>
        </ng-container>
      </div>
      <div class="pos-right d-flex justify-content-between align-items-center">
        <ng-container *ngFor="let button of addTemplateMeta['right']">
          <ng-container *ngTemplateOutlet="button"></ng-container>
        </ng-container>
      </div>
    </div>
    <div class="filter-sort-form">
      <div class="filter-sort-form-container">
        <ng-container
          *ngFor="let filter of filterContainerModel.filters; let i = index"
        >
          <div
            *ngIf="!filter.settings.hideFilter"
            [ngClass]="filter.settings.filterClass"
            [ngSwitch]="filter.type"
          >
            <rr-text-search-filter
              *ngSwitchCase="FilterType.TEXT_SEARCH"
              [model]="getTextFilter(filter)"
              (changedFilter)="onFilterChange($event)"
              (cleanFilterClicked)="onCleanFilterClicked($event)"
            ></rr-text-search-filter>
            <rr-date-range-filter
              *ngSwitchCase="FilterType.DATE_RANGE"
              [model]="getDateFilter(filter)"
              (changedFilter)="onFilterChange($event)"
              (cleanFilterClicked)="onCleanFilterClicked($event)"
            ></rr-date-range-filter>
            <rr-dropdown-filter
              *ngSwitchCase="FilterType.DROPDOWN_SELECT"
              [model]="getSingleOptionFilter(filter)"
              [formComponentSettings]="
                getSingleOptionFormSettings(filter.formSettings)
              "
              [options]="filter.options"
              [optionsTemplate]="
                getDropdownOptionsTemplate(filter.optionsTemplate)
              "
              (changedFilter)="onFilterChange($event)"
              (filterClicked)="onDropdownFilterClicked($event)"
              (cleanFilterClicked)="onCleanFilterClicked($event)"
            ></rr-dropdown-filter>
            <rr-checkbox-select-filter
              *ngSwitchCase="FilterType.CHECKBOX_SELECT"
              [formComponentSettings]="
                getCheckboxOptionsFormSettings(filter.formSettings)
              "
              [model]="getMultipleOptionsFilter(filter)"
              [options]="filter.options"
              (changedFilter)="onFilterChange($event)"
            ></rr-checkbox-select-filter>
            <rr-radio-select-filter
              *ngSwitchCase="FilterType.RADIO_SELECT"
              [formComponentSettings]="
                getSingleOptionFormSettings(filter.formSettings)
              "
              [model]="getSingleOptionFilter(filter)"
              [options]="filter.options"
              (changedFilter)="onFilterChange($event)"
            ></rr-radio-select-filter>
            <rr-multi-select-filter
              *ngSwitchCase="FilterType.MULTI_SELECT"
              [formComponentSettings]="
                getMultipleOptionsFormSettings(filter.formSettings)
              "
              [model]="getMultipleOptionsFilter(filter)"
              [options]="filter.options"
              (changedFilter)="onFilterChange($event)"
              (cleanFilterClicked)="onCleanFilterClicked($event)"
            ></rr-multi-select-filter>
            <ng-container *ngSwitchCase="FilterType.TAGS">
              <ng-container
                *ngIf="filter.settings.template"
                [ngTemplateOutlet]="filter.settings.template"
                [ngTemplateOutletContext]="{
                  model: filter,
                  tags: filter.options,
                  resetFilter: resetTagsFilter,
                  changedFilter: onFilterChange,
                  hasBeenReseted: onTagsFilterWasReseted
                }"
              >
              </ng-container>
              <rr-tags-filter
                *ngIf="!filter.settings.template"
                [model]="getTagsFilter(filter)"
                [tags]="getTags(filter.options)"
                [resetFilter]="resetTagsFilter"
                (changedFilter)="onFilterChange($event)"
                (hasBeenReseted)="onTagsFilterWasReseted()"
              >
              </rr-tags-filter>
            </ng-container>
          </div>
        </ng-container>
      </div>
      <div class="form-group reset-filters-container align-self-end text-right">
        <button
          *ngIf="filterContainerModel.activateResetButton"
          class="btn btn-outline-secondary btn-sm"
          type="button"
          (click)="resetFilters()"
          tooltip="Reset filters"
        >
          Reset
        </button>
        <button
          *ngIf="filterContainerModel.activateSubmitButton"
          class="btn btn-primary btn-sm ml-2"
          type="button"
          (click)="submitFilters()"
          tooltip="Submit filters"
          [disabled]="disableSubmitButton"
        >
          Filter
        </button>
      </div>
      <div
        *ngIf="showEndButtons"
        class="filter-metanav custom-group meta d-flex"
      >
        <ng-container *ngTemplateOutlet="addTemplateEnd"></ng-container>
      </div>
    </div>
  </div>
</div>
